import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { createSupportEmailWithLogs } from '../helpers/log-collector'

const TRANSLATION_LOCATION = 'pages.error_404.'

const Error404 = () => {
  const { t } = useTranslation()

  return (
    <div className='min-h-screen bg-white px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8'>
      <div className='mx-auto max-w-max'>
        <main className='sm:flex'>
          <p className='text-4xl font-extrabold text-blue-600 sm:text-5xl'>
            {t(TRANSLATION_LOCATION + 'code')}
          </p>
          <div className='sm:ml-6'>
            <div className='sm:border-l sm:border-gray-200 sm:pl-6'>
              <h1 className='text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl'>
                {t(TRANSLATION_LOCATION + 'title')}
              </h1>
              <p className='mt-1 text-base text-gray-500'>
                {t(TRANSLATION_LOCATION + 'instruction')}
              </p>
            </div>
            <div className='mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6'>
              <Link
                to='/'
                className='inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
              >
                {t(TRANSLATION_LOCATION + 'back_to_home')}
              </Link>
              <a
                href={createSupportEmailWithLogs(
                  'Dashboard 404 Error',
                  `Ich bin auf einen 404-Fehler gestoßen.\n\nURL: ${window.location.href}\nZeitpunkt: ${new Date().toISOString()}`
                )}
                className='inline-flex items-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-700 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
              >
                {t(TRANSLATION_LOCATION + 'contact_support')}
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export default Error404
